import axios from 'axios';
import connection from './connection';
// import {AllPlantCapacityResponse, PlantCapacityDto, PlantRequest,} from '@gtpl/shared-models/planning'
// import {CodeListDto, CodeListResponseModel, CodeListStatus} from '@gtpl/shared-models/planning'
import { CommonResponse } from '@gtpl/shared-models/masters';
import {LogsDto} from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import{LogsResponseModel} from 'libs/shared-models/user-logs/src/lib/Logs/logs-response.model'


export class LogsService {
  URL = connection.DEPLOY_URL + '/logs';

  async createLog(dto:LogsDto): Promise<LogsResponseModel> {
    console.log('@@@@@@@@@@@@')
    console.log(dto)

    return await axios
      .post(this.URL + '/createLog',dto)
      .then((res) => {
                return res.data;
      });
  }


}
